import $ from "jquery";


export default class FontUtil {
  constructor() {}

  init() {
    $(window).resize(() => {
      this.setFontSize();
    });

    this.setFontSize();
  }

  setFontSize() {
    let fontSize = $(window).width() / 375 * 10;

    if (fontSize > 12) {
      fontSize = 12;
    }
    // else if (fontSize < 10) {
    //   fontSize = 10;
    // }
    // console.log(fontSize);

    $("html").css({
      "font-size": `${fontSize}px`
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/FontUtil.js